import { Action } from '@ngrx/store';
import { LoginResponse, LoginRequest } from '../auth/auth.models';

export enum ActionTypes {
  LOGIN         = '[Msso Bypass] Login',
  LOGIN_SUCCESS = '[Msso Bypass] Login Success',
  LOGIN_FAILED  = '[Msso Bypass] Login Failed'
}

export class MssoBypassLoginAction implements Action {
  readonly type = ActionTypes.LOGIN;

  public constructor(public payload: LoginRequest) {
  }
}

export class MssoBypassLoginSuccessAction implements Action {
  readonly type = ActionTypes.LOGIN_SUCCESS;

  public constructor(public payload: LoginResponse) {
  }
}

export class MssoBypassLoginFailedAction implements Action {
  readonly type = ActionTypes.LOGIN_FAILED;

  public constructor(public payload: any) {
  }
}

export type Actions =
  MssoBypassLoginAction |
  MssoBypassLoginSuccessAction |
  MssoBypassLoginFailedAction;
